<template>
  <div>
    <h3 v-if="label.length">{{ label }}</h3>

        <div class="row">
          <div class="col-md-6">
            <IcFormRowWrapper
          rowElement="IcFormRow"
          id="type"
          name="train.type"
          :label="$t('label_train_type')"
          :aria="$t('required')"
          :labelWidth="4"
          :controlWidth="8"
        >
          <template slot-scope="{validator}">
            <IcSelect
              id="type"
              :values="trainTypes"
              v-model="data.type"
              @input="emitInput(data,validator)"
            />
          </template>
        </IcFormRowWrapper>
          </div>
          <div class="col-4" v-if="0 && data.type != '' && data.type != 'Skład wagonowy'">
            <IcFormRowWrapper
          rowElement="IcFormRow"
          id="count"
          name="train.count"
          :aria="$t('aria_required')"
          :label="$t('label_count')"
          :labelWidth="4"
          :controlWidth="8"
        >
          <template slot-scope="{validator}">
            <IcInput id="count" v-model="data.count" @input="emitInput(data,validator)" maxlength="20"></IcInput>
          </template>
        </IcFormRowWrapper>            
          </div>

        </div>
        <div class="row"  v-if="data.type == 'Skład wagonowy'">
          <div class="col-12">
            <IcFormCarriage
                v-model="data.carriages"
                :withCount="true"
                :maxCarriages = "8"
             >
            </IcFormCarriage>  
          </div>
        </div>
      </div>

</template>

<script>
import IcFormRow from "@/components/ic-common/form/helpers/FormRow.vue";
import IcFormRowHorizontal2 from "@/components/ic-common/form/helpers/FormRowHorizontal2.vue";
import IcSelect from "@/components/ic-common/form/controls/Select.vue";
import IcInput from "@/components/ic-common/form/controls/Input.vue";
import IcTextarea from "@/components/ic-common/form/controls/Textarea.vue";
import IcCheckbox from "@/components/ic-common/form/controls/Checkbox.vue";
import { Train } from "../Model/Train";
import { emitInput } from "./mixins";
import IcFormCarriage from "./Carriage"; 


export default {
  name: "IcFormTrain",
  props: {
    value: {
      type: [Object,Array],
    },
    label: {
      type: String,
      default: ""
    },    
  },
  data() {
    return {
      data: {
        count: ""
      },
      count: "",
      trainTypes: [
        {value:"Skład wagonowy",name:"Skład wagonowy"},
        {value:"ED250",name:"ED250"},
        {value:"ED160",name:"ED160"},
        {value:"ED161",name:"ED161"},
        {value:"ED74",name:"ED74"},
    ]
    };
  },
  watch: {
    value: function (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.data = this.value;
      }
    }
  },
  computed: {
   
  },
  mounted() {
   this.data = new Train();
  },

  methods: {
    emitInput,
  },
  components: {
    IcFormRow,
    IcFormRowHorizontal2,
    IcSelect,
    IcInput,
    IcTextarea,
    IcCheckbox,
    IcFormCarriage,
  }
};
</script>

<style></style>
